import { Component } from '@angular/core';

import { VideogularComponent } from '../Videogular.Component';

import { VBrickPlayerComponent } from 'vbrick-player-src/VbrickPlayer.Component';

import styles from './VgFullscreenButton.module.less';

/**
 * Component to switch between fullscreen and normal mode.
 *
 * <pre>
 * <videogular>
 *    <vg-media></vg-media>
 *
 *    <vg-controls>
 *        <vg-fullscreen-button></vg-fullscreen-button>
 *    </vg-controls>
 * </videogular>
 * </pre>
 *
 */
@Component({
	selector: 'vg-fullscreen-button',
	host: {
		'[class]': 'styles.root'
	},
	template: `
		<button
			type="button"
			[attr.aria-label]="vgApi.isFullScreen ? vbrickPlayer.translations.fullScreenEnd : vbrickPlayer.translations.fullScreenStart"
			[attr.aria-pressed]="!!vgApi.isFullScreen"
			[tooltip]="vgApi.isFullScreen ? vbrickPlayer.translations.fullScreenEnd : vbrickPlayer.translations.fullScreenStart"
			[placement]="'left'"
			[ngClass]="[
				styles.button,
				vgApi.isFullScreen ? 'vb-icon-fullscreen-exit' : 'vb-icon-fullscreen-enter'
			]"
			vbControlBarFocus
			(click)="vgApi.toggleFullScreen()">
		</button>
	`,
    standalone: false
})
export class VgFullscreenButtonComponent {
	public readonly styles = styles;

	constructor(
		public vbrickPlayer: VBrickPlayerComponent,
		public vgApi: VideogularComponent
	) {}
}
